
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import SkillsTab from './tabs/SkillsTab';
import AchievementsTab from './tabs/AchievementsTab';
import CareerTab from './tabs/CareerTab';
import { CareerLevel } from '../../types/game';
import DecisionHistoryTab from './tabs/DecisionHistoryTab';
import { useGame } from '../../contexts/GameContext';

interface CareerProgressTabsProps {
  experience: number;
  achievements: string[];
  careerLevel: CareerLevel;
}

const CareerProgressTabs: React.FC<CareerProgressTabsProps> = ({ 
  experience, 
  achievements,
  careerLevel
}) => {
  const { decisionHistory } = useGame();
  
  return (
    <Tabs defaultValue="career" className="w-full">
      <TabsList className="grid grid-cols-4 mb-4">
        <TabsTrigger value="career">
          Career Path
          <Badge variant="outline" className="ml-2 bg-web3-blue/20">{experience} XP</Badge>
        </TabsTrigger>
        <TabsTrigger value="skills">Skills</TabsTrigger>
        <TabsTrigger value="achievements">
          Achievements
          <Badge className="ml-2">{achievements.length}</Badge>
        </TabsTrigger>
        <TabsTrigger value="history">
          Decision History
          <Badge className="ml-2">{decisionHistory.length}</Badge>
        </TabsTrigger>
      </TabsList>
      
      <Card className="border-web3-blue/20 bg-web3-blue/5">
        <TabsContent value="career" className="p-4 min-h-[300px]">
          <CareerTab 
            experience={experience}
            careerLevel={careerLevel}
          />
        </TabsContent>
        
        <TabsContent value="skills" className="p-4 min-h-[300px]">
          <SkillsTab />
        </TabsContent>
        
        <TabsContent value="achievements" className="p-4 min-h-[300px]">
          <AchievementsTab achievements={achievements} />
        </TabsContent>
        
        <TabsContent value="history" className="p-4 min-h-[300px]">
          <DecisionHistoryTab decisions={decisionHistory} />
        </TabsContent>
      </Card>
    </Tabs>
  );
};

export default CareerProgressTabs;
